import { useMutation, useQueryClient } from "@tanstack/vue-query";
import Unipile from "@/services/unipile/unipile";
import type { ForwardWhatsAppMessageParams } from "./types";

/**
 * Composable for forwarding WhatsApp messages using TanStack Query
 */
export function useForwardWhatsAppMessage() {
  const queryClient = useQueryClient();

  const forwardMessageMutation = useMutation({
    mutationFn: async (params: ForwardWhatsAppMessageParams) => {
      const response = await Unipile.forwardMessage(params.messageId, {
        chat_id: params.chat_id,
      });

      if (!response.data?.status) {
        const errorData = response.data as any;
        throw new Error(errorData?.message || errorData?.msg || "Failed to forward message");
      }

      return response.data;
    },
    onSuccess: (data, variables) => {
      // Invalidate messages query for target conversation
      queryClient.invalidateQueries({
        queryKey: ["whatsapp-messages", variables.chat_id],
      });

      // Also invalidate conversations to update last message
      queryClient.invalidateQueries({
        queryKey: ["whatsapp-conversations"],
      });
    },
  });

  return {
    forwardMessage: forwardMessageMutation.mutateAsync,
    isForwarding: forwardMessageMutation.isPending,
    forwardError: forwardMessageMutation.error,
  };
}
